import MarketMapper from './market-mapper';
import SpecifierModel from '../specifier/specifier-model';
import OutcomeModel from '../outcome/outcome-model';

const MarketModel = {
    mapper: MarketMapper,

    dynamic: {
        fieldName: 'd',
        type: Boolean,
    },

    frozen: {
        fieldName: 'f',
        type: Boolean,
    },

    marketHash: {
        fieldName: 'h',
        type: String,
    },

    marketRefId: {
        fieldName: 'r',
        type: String,
    },

    mbn: {
        fieldName: 'b',
        type: Number,
    },

    names: {
        fieldName: 'n',
        type: Object,
    },

    outcomes: {
        fieldName: 'o',
        model: OutcomeModel,
        type: Array,
    },

    outcomeNames: {
        fieldName: 'm',
        type: Object,
    },

    specifiers: {
        fieldName: 'p',
        model: SpecifierModel,
        type: Array,
    },

    status: {
        fieldName: 's',
        type: Number,
    },
};

export default MarketModel;
